<template>
    <!-- 专家问诊列表 -->
    <div class="page-container physician-inquiry-home-container" :class="{'err-bg':isError}">
        <!-- 搜索 -->
        <!-- <div class="search-container" @click="onClickSearch">
            <div class="search">
                <i class="icon"></i>
                <span class="txt">搜索医院、医生、科室、疾病</span>
            </div>
        </div> -->

		<!-- 疾病 -->
		<div class="tag-container">
			<ul class="tag-list">
				<li class="tag-list-item" v-for="item in DieaseList" :key="item.diseaseId" @click="toDotorListPage(item.id)">{{item.diseaseName}}</li>
			</ul>
		</div>

		<!-- 列表 -->
        <div class="list-container">
			<div class="list" v-for = "(item,index) in departmentList" :key="index">
				<p class="title">{{item.stdDeptName}}<span>（{{item.doctorNumber}}位中医生）</span></p>
				<ul class="list-dep">
					<li class="item" v-for="(dep,i) in item.stdDeptList" :key="i" @click="toDoctorList(dep)">
						{{dep.stdDeptName}}
					</li>
					<template v-if="item.stdDeptName === '中医内科'">
					<li class="item " @click="toDoctorList(item,'unlimit')">
						不限
					</li>
					</template>
				</ul>
			</div>
        </div>

		<template v-if="isError">
			<page-error :title="error" :height="height"></page-error>
		</template>
    </div>
</template>

<script>
import { DepartmentListHome } from '@/api/doctor.js'
import { DieaseList } from '@/api/common.js'
export default {
    data () {
        return {
            isLoadMore: true,
            height: false,
            isError: false,
			error:'抱歉，暂无数据',
			DieaseList: [],
			departmentList: [],
			areaId: '',	// 区域id
			toHospitalName: '',
			toHospitalDomainName: ''
        }
    },
    created () {
		this.userAgent = this.$getUserAgent
    },
    mounted () {
		const areaInfo = JSON.parse(sessionStorage.getItem('AreaInfo'))

		this.areaId = areaInfo.areaId
		this.toHospitalName = areaInfo.toHospitalName
		this.toHospitalDomainName = areaInfo.toHospitalDomainName
		this.getDieaseList()
		this.getDepartmentList()
		this.share()
    },
    methods: {
        // 微信分享
        share() {
            if(this.userAgent === 'weixin') {
                // 分享
                this.$weixinShare({
                    title: this.toHospitalName + '·中医专家问诊',
                    desc: '中医专家 在线开药',
                    imgUrl: window.location.origin + '/share.jpg'
                })
            }
        },

        // 加载中
        showLoading () {
            this.$wand.loading.show({disableClick: false})
        },

        // 加载完成
        hideLoading () {
            this.$wand.loading.hide()
		},

		// 获取疾病列表
		getDieaseList () {
			let params = {
				pageNumber: 1,
				pageSize: 10,
				areaId: this.areaId
			}

			DieaseList(params).then(async res => {
                this.DieaseList = res.results
			}).catch(err => {
                this.pageError()
				console.log('err: ', err)
			})
		},

		// 获取科室列表
		getDepartmentList () {
			let params = {
				areaId: this.areaId
			}
			// 加载中
			this.showLoading()
			DepartmentListHome(params).then(async res => {
				this.departmentList = res

				for (let i of res) {
					let stdDeptIdList = ''
					for (let j of i.stdDeptList) {
						if (i.stdDeptName === '中医内科') {
							stdDeptIdList += j.stdDeptId + ','
						}
					}
					i.stdDeptIdList = stdDeptIdList
				}

				this.hideLoading()

				if(res.length === 0) {
					this.isError = true
				}
			}).catch(err => {
                this.isError = true
                this.error = '服务器错误，请重试'
                this.hideLoading()
                window.scrollTo(0,0)
				console.log('err: ', err)
			})
		},

        // 点击搜索跳转到门户
        onClickSearch () {
			const isTest = window.location.href.indexOf('guahao-test') > -1 ? true : false

			// 测试环境
			if (isTest) {
				window.location.href = 'http://' + this.toHospitalDomainName + '/consult/more?qarea='+ this.areaId +
			'&qcity='+ this.areaName
			} else {
				// 线上
				window.location.href ='https://' + this.toHospitalDomainName + '/consult/more?qarea='+ this.areaId +
			'&qcity='+ this.areaName
			}

		},

		// 跳转到疾病对应医生列表,传区域疾病id
        toDotorListPage (tcmAreaDiseaseId) {
			this.$router.push({path:'/physician-inquiry/list', query: {tcmAreaDiseaseId: tcmAreaDiseaseId}})
		},

		// 跳转到科室对应医生列表
		toDoctorList (item,tag) {
			let stdDeptId = (tag === 'unlimit')?item.stdDeptIdList:item.stdDeptId

			if (tag === 'unlimit') {
				stdDeptId = stdDeptId.slice(0,stdDeptId.length-1)
			}
			console.log(stdDeptId)
			this.$router.push({path:'/physician-inquiry/list', query: {stdDeptId: stdDeptId}})
		},

  }
}
</script>

<style lang="less" scoped>
    @import '~@/assets/style/page/physician-inquiry-home.less';
</style>
